"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFacingBootcampSchema = exports.BootcampEnrollmentSchema = exports.BootcampSchema = void 0;
const zod_1 = require("zod");
const language_codes_types_1 = require("./language_codes_types");
// ZOD SCHEMAS
exports.BootcampSchema = zod_1.z.object({
    endDate: zod_1.z.string(),
    id: zod_1.z.string(),
    knownCode: language_codes_types_1.KnownLanguageCodeSchema,
    learnCode: language_codes_types_1.LearnLanguageCodeSchema,
    sizeLimit: zod_1.z.number(),
    startDate: zod_1.z.string(),
});
exports.BootcampEnrollmentSchema = zod_1.z.object({
    bootcampId: zod_1.z.string(),
    isIntense: zod_1.z.boolean(),
    isPrivate: zod_1.z.boolean(),
    isSixBootcamps: zod_1.z.boolean(),
    paymentId: zod_1.z.string(),
    userId: zod_1.z.string(),
});
exports.UserFacingBootcampSchema = exports.BootcampSchema.pick({
    endDate: true,
    id: true,
    startDate: true,
});
//# sourceMappingURL=mxu_bootcamp_types.js.map